import React, { Component } from 'react';
import { lang } from'../Helpers/lang';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import Select from 'react-select';
import $ from 'jquery';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import axios from 'axios';
import { computeFilterFromHex } from '../Helpers/cssFilterSolver';
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class Edit extends Component {
	
	constructor(props)
	{
		super(props);
		const id = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;

		this.state = {
		  list_id : id,
	      login_type:'',
		  show_count_yes:true,
		  show_count_no:false,		 
	      name:'',
	      module_type:'',
	      module_type_value:'',
	      priorty:'',
		  content:'',
		  image_preview:'',
		  image_name:'',
		  image:'',
	      name_arr:[],
	      module_type_arr:[],
	      module_type_value_arr:[],
	      priorty_arr:[],
		  content_arr:'',
		  image_preview_arr:'',
		  image_name_arr:'',
	      showlayout: false,
	      select_options:'',
	      select_options_arr:[],
	      selectedvalue: '',
          selectedOption:{ value: 'active', label: 'Active'},
          Loading:false,
		  show_count_arr:[],
		  image_arr:[],
		  icon_image: [],
		  icon_image_arr:[],
          editindex:'',
          field_ids:[],
		  remove_ids:'',
		  removeall_ids:'',
		  login_type:'',
		  image_name_single:'',
		   bg_image_name_arr:'',
		  bg_image_name:'',
		  bg_image_preview: '',
		  bg_image: '',
		  db_bg_image_name:'',
		  show_count: 'yes',
		  show_tooltip: 'yes',
		  icon_color:'',
		  show_count: 'yes',
		  text_color:'',
		  text_color_arr:[],
		  text_size:'',
		  text_size_arr:[],
		  count_size:'',
		  count_size_arr:[],
		  icon_image_preview_arr: '',
		  icon_image_name_arr: '',
		  enable_list:false,
		  enable_list_arr: [],
		  dashboard_img_type:'dashboard_img',
		  dashboard_img_type_arr:[],
		  dashb_img_max_height:'',
		  dashb_img_max_height_arr:[],
		  dashb_img_max_width:'',
		  dashb_img_max_width_arr:[],
		  dashb_img_position:'',
		  dashb_img_position_arr:[],
		  dashboard_blocks: [],
		  icon_color_filter: '',
		  icon_color_loss: '',
		  dashboarddata:[],
		  edit_column_id:'',
		  icon_width:''

		};
    this.deletesinglefield = this.deletesinglefield.bind(this);

	var qs = require('qs');
	var listid = this.state.list_id;

	axios.get(apiUrl+"dashboardmanagment/listdetail?id="+listid).then(res => {
		if(res.data.status == "success" ){
			this.setState({dashboarddata:res.data.dashboarddata})
			if (res.data.dashboard_blocks) {
			const blocksWithIds = res.data.dashboard_blocks.map(block => ({
				...block,
				dashboard_id: this.state.list_id,
				image_name: block.image_name || '',
				action: 'no'
			}));
			this.setState({ dashboard_blocks: blocksWithIds });
			}
		}
		const formdata = res.data.data;
						this.setState({login_type : {value:formdata.usertype, label:formdata.usertype}, showlayout: true, login_type_value: formdata.usertype});
						
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field});
					  	}
					  	if(formdata.priority){
							  this.setState({priorty_arr: formdata.priority});
						}
						
						if(formdata.count_size){
							this.setState({count_size_arr: formdata.count_size});
						}
						if(formdata.priority){
							this.setState({text_color_arr: formdata.text_color});
						}
						if(formdata.priority){
							this.setState({text_size_arr: formdata.text_size});
						}
					  	if(formdata.select_option){
						
					  		this.setState({module_type_value_arr : formdata.select_option});
					  	}
					  	if(formdata.image){
					  		this.setState({image_name_arr: formdata.image, image_arr: formdata.image});
					  	}
					  	if(formdata.column_id){
					  		this.setState({field_ids: formdata.column_id});
					  	}
					  	if(formdata.show_count){
					  		this.setState({show_count_arr: formdata.show_count});
					  	}
		                
						if (formdata.enable_list_icon) {
							this.setState({ icon_image_name_arr: formdata.enable_list_icon, icon_image_arr: formdata.enable_list_icon });
						}

						if (formdata.enable_list) {
							this.setState({ enable_list_arr: formdata.enable_list });
						}
						if (formdata.dashboard_img_type) {
							this.setState({ dashboard_img_type_arr: formdata.dashboard_img_type });
						}

						if (formdata.dashb_img_max_height) {
							this.setState({ dashb_img_max_height_arr: formdata.dashb_img_max_height });
						}
						if (formdata.dashb_img_max_width) {
							this.setState({ dashb_img_max_width_arr: formdata.dashb_img_max_width });
						}
						if (formdata.dashb_img_position) {
							this.setState({ dashb_img_position_arr: formdata.dashb_img_position });
						}

						
						
	
	}); 
 }
	
	componentDidMount() {
		  	if(localStorage.getItem("admin_id") === 'undefined' && localStorage.getItem('admin_id') === '' && localStorage.getItem('admin_id') === null){
			this.props.history.push('/');
		}
  }

  getdashbordlistdetails = () => {
	var qs = require('qs');
	var listid = this.state.list_id;

	axios.get(apiUrl+"dashboardmanagment/listdetail?id="+listid).then(res => {
		const formdata = res.data.data;
						this.setState({login_type : {value:formdata.usertype, label:formdata.usertype}, showlayout: true, login_type_value: formdata.usertype});
						this.setState({dashboard_img_type_arr:formdata.dashboard_img_type,dashb_img_max_height_arr:formdata.dashb_img_max_height,dashb_img_max_width_arr:formdata.dashb_img_max_width})
					  	// if(formdata.dashb_img_position!=''){
						// 	this.setState({
						// 		dashb_img_position_ob: lang.common.dashboard_img_position.filter(obj => obj.value === formdata.dashb_img_position),dashb_img_position:formdata.dashb_img_position
						// });
					    //}
						this.setState({dashb_img_position_arr : formdata.dashb_img_position})
						if(formdata.field){
					  		this.setState({name_arr: formdata.field});
					  	}
					  	if(formdata.priority){
					  		this.setState({priorty_arr: formdata.priority});
					  	}
					  	if(formdata.select_option){

					  		this.setState({module_type_value_arr : formdata.select_option});
					  	}
					  	if(formdata.image){
					  		this.setState({image_name_arr: formdata.image, image_arr: formdata.image});
					  	}
					  	if(formdata.column_id){
					  		this.setState({field_ids: formdata.column_id});
					  	}
					  	if(formdata.show_count){
					  		this.setState({show_count_arr: formdata.show_count});
					  	}

					  	if (formdata.dashboard_blocks) {
					  		const blocksWithIds = formdata.dashboard_blocks.map(block => ({
					  			...block,
					  			dashboard_id: this.state.list_id,
					  			image_name: block.image_name || '',
					  			action: 'update'
					  		}));
					  		this.setState({ dashboard_blocks: blocksWithIds });
					  	}
		
	
	}); 
  }
	handleInputChange = (event) =>{
    const { name, value, checked, type } = event.target;
    // const { name,value } = event.target;
	 this.setState({
		[name]: type === "checkbox" ? checked : value
	});
    // this.setState({[name]: value})
	if(name == "icon_color"){
		const hex = event.target.value;
		this.setState({ icon_color: hex });
		
		const { filter, loss } = computeFilterFromHex(hex);
		this.setState({ icon_color_filter: filter, icon_color_loss: loss });
	}
     if(name === 'form_column'){
       this.setState({form_one_column: !this.state.form_one_column});
       this.setState({form_two_column: !this.state.form_two_column});
    }
    if(name === 'field_required'){
        this.setState({field_required_checked: !this.state.field_required_checked});
    }
    if(name == 'select_options'){
        this.setState({select_options:value})
    }
	if (name === 'show_count') {
		this.setState({ show_count: value });
	}

	if (name === "enable_list") {
		this.setState({
		enable_list: checked 
		});
	}
	
	
	  //console.log(this.state.count_size,"--this.state.count_size");
  }

  handleChange = login_type => {
	this.setState({login_type})
	this.setState({  login_type_value : login_type.value});
  };

  handleDashboardBlockChange = (index, field, value) => {
	const blocks = [...this.state.dashboard_blocks];
	blocks[index] = {
		...blocks[index],
		[field]: value,
		action: blocks[index].id ? 'update' : 'add'
	};
	this.setState({ dashboard_blocks: blocks });
  }


  handleFormSubmit = () => {
	
		this.setState({Loading:true});
			const config = {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
			};

		const formPayload = this.state;
		var qs = require('qs');

		var postObject = {
			admin_id : localStorage.getItem("admin_id"),
			list_id : this.state.list_id,
			edit_id:this.state.dashboarddata[this.state.editindex].column_id,
			field_ids : formPayload.field_ids,
			user: formPayload.login_type_value,
			name_arr: formPayload.name_arr,
			module_type_value_arr: formPayload.module_type_value_arr,
			priorty_arr: formPayload.priorty_arr,
			text_size_arr: formPayload.text_size_arr,
			text_color_arr: formPayload.text_color_arr,
			count_size_arr: formPayload.count_size_arr,
			show_count_arr:formPayload.show_count_arr,
			content_arr: formPayload.content_arr,
			removeid: formPayload.remove_ids,
			removeallid: formPayload.removeall_ids,
			enable_list_arr: formPayload.enable_list_arr,
			dashboard_img_type_arr:formPayload.dashboard_img_type_arr,
			dashb_img_max_height_arr:formPayload.dashb_img_max_height_arr,
			dashb_img_max_width_arr:formPayload.dashb_img_max_width_arr,
			dashb_img_position_arr:formPayload.dashb_img_position_arr,
			dashboard_blocks: JSON.stringify(formPayload.dashboard_blocks.map(block => ({
				id: block.id || '',
				dashboard_id: block.dashboard_id,
				title: block.title || '',
				color: block.color || '',
				image_name: block.image_name || '',
				action: block.action
			}))),
			image_name_single:this.state.image_name_single,
			db_bg_image_name:this.state.db_bg_image_name,
			 current_edit_values: JSON.stringify({
        name: this.state.name,
        priorty: this.state.priorty,
        link_page: this.state.module_type_value,
        dashboard_block: this.state.dashboard_block,
        show_tooltip: this.state.show_tooltip,
        icon_width: this.state.icon_width,
        text_color: this.state.text_color,
        text_size: this.state.text_size,
        count_color: this.state.count_color,
        count_size: this.state.count_size,
        content: this.state.content,
        show_count: this.state.show_count,
		icon_color: this.state.icon_color,
		svg_icon_color:this.state.icon_color_filter,
		dashboard_img_type:this.state.dashboard_img_type,
		dashb_img_max_height:this.state.dashb_img_max_height,
		dashb_img_max_width:this.state.dashb_img_max_width,
		dashb_img_position:this.state.dashb_img_position
    })
		};
		//this.props.getEditForm(qs.stringify(postObject));
		console.log(postObject,"postObject");
		//return false;
		let formData = new FormData();

		for(let k in postObject) {
			formData.append(k, postObject[k]);
		}
		var filesdata = this.state.image_arr;

		var iconFilesData = Array.isArray(this.state.icon_image_arr) ? this.state.icon_image_arr : this.state.icon_image ? [this.state.icon_image] : [];

		console.log(iconFilesData,'iconFilesData')
			formPayload.name_arr.forEach((row, index) => {
				filesdata.forEach((image, i) => {
					if(index == i){
						formData.append(`update_image[${index}]`, image);
					}
					
				});

			});
			if (this.state.image) {
				formData.append("update_image", filesdata[this.state.editindex]);
			}
			if (this.state.icon_image) {
				formData.append("single_icon", this.state.icon_image);
			}
			if (this.state.bg_image) {
					formData.append("update_bgimage", this.state.bg_image);
			}

			formPayload.dashboard_blocks.forEach((block, index) => {
				if (block.image && typeof block.image === 'object') {
					formData.append(`dashboard_block_image[${index}]`, block.image);
				}
			});

		axios.post(apiUrl+"dashboardmanagment/edit",formData,config).then(res => {
			if(res.data.status === "success"){
				this.setState({Loading:false});
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				scrollToTop();
				setTimeout(function() {
					$('.success_message').html('');
					this.getdashbordlistdetails();
				}.bind(this), 3000);
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				scrollToTop();
				setTimeout(function() {
					$('.success_message').html('');
				}.bind(this), 3000);
			}
		});
	}


  Addtolayout=()=>{

	  	var showcount;
		if(this.state.show_count_yes == true){
			showcount = 'yes';
		}else{
			showcount = 'no';
		}
		  var Index = this.state.editindex;
		  console.log(Index, "this.state.editindex from Addtolayout");
		let fieldname = [...this.state.name_arr];
		let fieldtype = [...this.state.module_type_value_arr];
		let priority = [...this.state.priorty_arr];
			let count_size = [...this.state.count_size_arr];
			let text_color = [...this.state.text_color_arr];
			let text_size = [...this.state.text_size_arr];
		let content = [...this.state.content_arr]; 
		let image = [...this.state.image_arr]; 
		let iconImage = [...this.state.icon_image_arr]; 
		let enableList = [...this.state.enable_list_arr];
		
		let show = [...this.state.show_count_arr]; 
		let dashboard_img_type = [...this.state.dashboard_img_type_arr];
		let dashb_img_max_height = [...this.state.dashb_img_max_height_arr];
        let dashb_img_max_width = [...this.state.dashb_img_max_width_arr];
        let dashb_img_position = [...this.state.dashb_img_position_arr];

		
		if(Index !==''){
		
			fieldname.splice(Index, 1,this.state.name);	
			fieldtype.splice(Index, 1,this.state.module_type_value);
			priority.splice(Index, 1,this.state.priorty);
			count_size.splice(Index, 1,this.state.count_size);
			text_color.splice(Index, 1,this.state.text_color);
			text_size.splice(Index, 1,this.state.text_size);
			content.splice(Index, 1,this.state.content);
			image.splice(Index,1,this.state.image);
			iconImage.splice(Index,1,this.state.iconImage);
			show.splice(Index,1,this.state.show_count);
			enableList.splice(Index, 1, this.state.enable_list);
			dashboard_img_type.splice(Index, 1, this.state.dashboard_img_type);
			dashb_img_max_height.splice(Index, 1, this.state.dashb_img_max_height);
			dashb_img_max_width.splice(Index, 1, this.state.dashb_img_max_width);
			dashb_img_position.splice(Index, 1, this.state.dashb_img_position);
			this.setState({name_arr: fieldname,module_type_value_arr: fieldtype,content_arr:content,priorty_arr:priority, count_size_arr:count_size, text_color_arr:text_color, text_size_arr:text_size,image_arr:image,icon_image_arr:iconImage, show_count_arr:show, enable_list_arr: enableList, dashboard_img_type_arr:dashboard_img_type,dashb_img_max_height_arr:dashb_img_max_height,dashb_img_max_width_arr:dashb_img_max_width,dashb_img_position_arr:dashb_img_position});
		}else{
			
			this.setState({
				name_arr: this.state.name_arr.concat(this.state.name),
				module_type_value_arr: this.state.module_type_value_arr.concat(this.state.module_type_value),
				priorty_arr: this.state.priorty_arr.concat(this.state.priorty),
				content_arr: this.state.content_arr.concat(this.state.content),
				image_arr: this.state.image_arr.concat(this.state.image),
				icon_image_arr: this.state.icon_image_arr.concat(this.state.iconImage),
				count_size_arr: this.state.count_size_arr.concat(this.state.count_size),
				text_color_arr: this.state.text_color_arr.concat(this.state.text_color),
				text_size_arr: this.state.text_size_arr.concat(this.state.text_size),
				enable_list_arr: this.state.enable_list_arr.concat(this.state.enable_list),
				dashboard_img_type_arr:this.state.dashboard_img_type_arr.concat(this.state.dashboard_img_type),
				dashb_img_max_height_arr:this.state.dashb_img_max_height_arr.concat(this.state.dashb_img_max_height),
				dashb_img_max_width_arr:this.state.dashb_img_max_width_arr.concat(this.state.dashb_img_max_width),
				dashb_img_position_arr:this.state.dashb_img_position_arr.concat(this.state.dashb_img_position)

				});
				// if(this.state.show_count_yes == true){
				// 	var show_count = 'yes';
				// }else{
				// 	var show_count = 'no';
				// }
				this.setState({show_count_arr: this.state.show_count_arr.concat(this.state.show_count)})
		}
	    
		
	
		this.setState({showlayout: true},function(){
		//this.setState({name:'',module_type:'',module_type_value:'',priorty:'',content:'',editindex:'',image_name_single:'',icon_name_single:'',text_color:'',text_size:'',count_size:'',dashboard_img_type:'dashboard_img',dashb_img_max_height:'',dashb_img_max_width:'',dashb_img_position:'middle-center'});
		this.getformlayout();
		scrollToTop();
		$('#addbutton').html('Add');
		});
  }

  validateFormfield() {
		const {form_field_name,form_input_type_value,field_required,field_priorty,select_options} = this.state;
		let errors = 0;
	
		if (!form_field_name) {
			errors++;
			$('.errorfieldname').html('<span class="errorspan">Please fill the field</span>');
		}else if(form_field_name){
			$('.errorfieldname').html('');
		}


		if (!form_input_type_value) {
			errors++;
			$('.errortype').html('<span class="errorspan">Please select input type</span>');
		}else if(form_input_type_value){
			$('.errortype').html('');
		}

		if(!field_priorty){
		errors++;
			$('.errorpriority').html('<span class="errorspan">Please fill the field</span>');
		}else if(field_priorty){
			$('.errorpriority').html('');
		}

		if(form_input_type_value == 'select'){
			if(!select_options){
				errors++;
				$('.erroroptions').html('<span class="errorspan">Please fill the field</span>');
			}else if(select_options){
				$('.erroroptions').html('');
			}
		}

		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

    }

       componentWillReceiveProps(Props){

    	   if(Props.formdetail !== this.props.formdetail){
    		if(Object.keys(Props.formdetail).length > 0){
				this.setState({Loading:false});
					//console.log(Props.carlist);
					if(Props.formdetail[0].status === "success"){

						const formdata = Props.formdetail[0].formdata;
						this.setState({form_name : formdata.formname});
						if(formdata.formcolumn == 1){
							this.setState({form_one_column: true,form_two_column: false});
						}else{
							this.setState({form_two_column: true,form_one_column:false})
						}
						if(formdata.formstatus === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
						}
					
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field,showlayout:true});
					  	}
					  	if(formdata.priority){
					  		this.setState({field_priorty_arr: formdata.priority});
						}

						if(formdata.text_size){
							this.setState({field_text_size_arr: formdata.text_size});
						}
						if(formdata.text_color){
							this.setState({field_text_color_arr: formdata.text_color});
						}
						if(formdata.count_size){
							this.setState({field_count_size_arr: formdata.count_size});
						}
					  	if(formdata.required){
					  		this.setState({field_required_arr : formdata.required});
					  	}
					  	if(formdata.fieldtype){
					  		this.setState({form_input_type_value_arr: formdata.fieldtype});
					  	}
					  	if(formdata.field_id){
					  		this.setState({field_ids: formdata.field_id});
					  	}
					  	if(formdata.options){
					  		this.setState({select_options_arr: formdata.options});
					  	}
					}
    		}
    	}

    if(Props.formedit !== this.props.formedit){

    		if(Object.keys(Props.formedit).length > 0){

    			this.setState({ Loading: false });

    			if(Props.formedit[0].status === "success"){
    				

						const formdata = Props.formedit[0].formdata;
						this.setState({form_name : formdata.formname});
						if(formdata.formcolumn == 1){
							this.setState({form_one_column: true,form_two_column: false});
						}else{
							this.setState({form_two_column: true,form_one_column:false})
						}
						if(formdata.formstatus === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
						}
					
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field,showlayout:true});
					  	}
					  	if(formdata.priority){
					  		this.setState({field_priorty_arr: formdata.priority});
						}
						
						if(formdata.count_size){
							this.setState({field_count_size_arr: formdata.count_size});
						}
						if(formdata.text_color){
							this.setState({field_text_color_arr: formdata.text_color});
						}
						if(formdata.text_size){
							this.setState({field_text_size_arr: formdata.text_size});
						}
					  	if(formdata.required){
					  		this.setState({field_required_arr : formdata.required});
					  	}
					  	if(formdata.fieldtype){
					  		this.setState({form_input_type_value_arr: formdata.fieldtype});
					  	}
					  	if(formdata.field_id){
					  		this.setState({field_ids: formdata.field_id});
					  	}
					  	if(formdata.options){
					  		this.setState({select_options_arr: formdata.options});
					  	}

					  	$('.success_message').html('<div class="status_sucess"><h3>'+ Props.formedit[0].message+'</h3></div>');
	                	scrollToTop();
	    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					
    			}else{
    			$('.success_message').html('<div class="status_sucess"><h3>'+ Props.formedit[0].message+'</h3></div>');
                	scrollToTop();
    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
    		 }
    	}
    }
  }
  deletesinglefield(Index, id){
      let fieldname = [...this.state.name_arr];
      let fieldtype = [...this.state.module_type_value_arr];
      let showcount = [...this.state.show_count_arr];
	  let enableList = [...this.state.enable_list_arr];
	  let fieldpriorty = [...this.state.priorty_arr]; 
	  let fieldtext_size = [...this.state.text_size_arr]; 
      let fieldtext_color = [...this.state.text_color_arr]; 
      let fieldcount_size = [...this.state.count_size_arr]; 
	  let content = [...this.state.content_arr]; 
      let fieldids = [...this.state.field_ids]; 
      fieldname.splice(Index, 1);
      fieldtype.splice(Index, 1);
      showcount.splice(Index, 1);
	  enableList.splice(Index, 1);
	  fieldpriorty.splice(Index, 1);
	  fieldtext_size.splice(Index, 1);
      fieldtext_color.splice(Index, 1);
      fieldcount_size.splice(Index, 1);
      content.splice(Index, 1);
      fieldids.splice(Index, 1);
	  this.setState({name_arr: fieldname,module_type_value_arr: fieldtype,show_count_arr:showcount,priorty_arr:fieldpriorty,content_arr:content,field_ids:fieldids,
		count_size_arr:fieldcount_size,
		text_color_arr:fieldtext_color,
		enable_list_arr: enableList,
		text_size_arr:fieldtext_size});
	  this.setState(prevState => ({
		remove_ids: [...prevState.remove_ids, id]
	  }))
  }
  editsinglefield = (index) => {
	console.log(index);
	$('.error_name').html('');
		$('.error_module_type_value').html('');
		$('.error_priorty').html('');
		$('.error_count_size').html('');
		$('.error_text_color').html('');
		$('.error_text_size').html('');
		this.setState({name:this.state.name_arr[index],priorty:this.state.priorty_arr[index],text_size:this.state.text_size_arr[index], 
			text_color:this.state.text_color_arr[index],
			count_size:this.state.count_size_arr[index],
			content: this.state.content_arr[index],
			editindex: index,
			dashboard_img_type:this.state.dashboard_img_type_arr[index],
			dashb_img_max_height:this.state.dashb_img_max_height_arr[index],
			dashb_img_max_width:this.state.dashb_img_max_width_arr[index],
			dashb_img_position:this.state.dashb_img_position_arr[index],


		});
		console.log(this.state.dashboarddata);
		const editdata =  this.state.dashboarddata[index];
		console.log(editdata,"editdata");
		if(this.state.dashboarddata[index]?.icon_color){
			
			const hex = editdata.icon_color;			
			const { filter, loss } = computeFilterFromHex(hex);
			this.setState({ icon_color_filter: filter, icon_color_loss: loss,
				dashboard_block: editdata.dashboard_block,
				show_tooltip: editdata.show_tooltip,
				icon_width: editdata.icon_width,
				icon_color: editdata.icon_color,
			 });
		}
		if(this.state.dashb_img_position_arr[index]!=''){
			this.setState({
				dashb_img_position_ob: lang.common.dashboard_img_position.filter(obj => obj.value === this.state.dashb_img_position_arr[index]),dashb_img_position:this.state.dashb_img_position_arr[index]
			});						
		}
  		var fieldtype = this.state.module_type_value_arr[index];
  		// var fieltypeval =fieldtype.charAt(0).toUpperCase() + fieldtype.slice(1);
  		
  		// this.setState({form_input_type: {value: fieldtype, label: fieltypeval},form_input_type_value: fieldtype});
		  var contr =[];
		  for(let i=0; i<lang.common.dashboard_page_options.length; i++){
		  if(lang.common.dashboard_page_options[i].value == this.state.module_type_value_arr[index]){
		 	 contr.push(lang.common.dashboard_page_options[i])
		  }
		  }
  		if(this.state.show_count_arr[index] == 'yes'){
  			this.setState({show_count : this.state.show_count_arr[index],show_count_no: false})
  		}else{
			this.setState({show_count : this.state.show_count_arr[index],show_count_no: true})
  		}
  		if(this.state.select_options_arr[index]!==''){
  			this.setState({select_options:this.state.select_options_arr[index]});
  		}
		if(this.state.image_name_arr[index]!=='' && this.state.image_name_arr[index]!==null){
			this.setState({image_name_single:this.state.image_name_arr[index], image_preview:''});
		}else{
			this.setState({image_preview:''});
		}

		if (this.state.enable_list_arr[index] == 'true') {
			this.setState({ enable_list: this.state.enable_list_arr[index]})
		} else {
			this.setState({ enable_list: this.state.enable_list_arr[index]})
		}

		if (this.state.icon_image_name_arr[index] !== '' && this.state.icon_image_name_arr[index] !== null) {
			this.setState({ icon_name_single: this.state.icon_image_name_arr[index], icon_preview: '' });
		} else {
			this.setState({ icon_name_single: '', icon_preview: '' });
		}
		console.log(lang.common.dashboard_page_options,"lang.common.dashboard_page_options");
		const selectedblock = lang.common.dashboard_blocks.find(
			(opt) => opt.value === editdata.dashboard_block
			);

		const selectedlink = lang.common.dashboard_page_options.find(
			(opt) => opt.value === editdata.select_option
		);
		console.log(selectedlink,editdata.select_option);
				 // this.setState({module_type: contr,module_type_value: this.state.module_type_value_arr[index]})

		
					this.setState({
					dashboard_block_sel: selectedblock ? [selectedblock] : [],
					dashboard_block: editdata.dashboard_block,
					module_type: selectedlink,
					module_type_value:editdata.select_option
					});
		if(this.state.bg_image_name_arr[index]){
			this.setState({db_bg_image_name:this.state.bg_image_name_arr[index],bg_image_preview:''});
		}else{
			this.setState({db_bg_image_name:'',bg_image_preview:''});
		}
		$('#addbutton').html('Update');
  }
  getformlayout(){
      var form_field_value = this.state.name_arr;
      if (Object.keys(form_field_value).length > 0) {
      const formlayout = form_field_value.map(
      (datas, Index) => {
      let indexdata = Index+1;
      return (
            <div key={Index+'list'}>
            <li className="sortablecontainer-module-list">
            {/* <i class="fa fa-chevron-right" aria-hidden="true"></i> */}
			<b>{indexdata}. </b>
            {datas}
            <div className="d-flex gap-2 align-items-center" style={{float:"right"}}>
				<i className="ft-edit-3 position-relative cursor-pointer" aria-hidden="true" onClick={this.editsinglefield.bind(this,Index)} ></i>
				<i className="ft-trash-2 position-relative cursor-pointer" aria-hidden="true" onClick={this.deletesinglefield.bind(this,Index, this.state.field_ids[Index])}></i>
            {/* <button onClick={this.editsinglefield.bind(this,Index)} > Edit</button> */}
            {/* <button onClick={this.deletesinglefield.bind(this,Index, this.state.field_ids[Index])}> Delete</button> */}
            </div>
            </li></div> );

      }
      );
      return formlayout;
      }
  }
  getdeleteall = (ids) =>{
	  this.setState({showlayout:false,name_arr:[],form_input_type_arr:[],form_input_type_value_arr:[],field_priorty_arr:[],field_count_size_arr:[],field_text_color_arr:[],field_text_size_arr:[],field_required_arr:[],select_options_arr:[]});
	  this.setState(prevState => ({
		removeall_ids: [...prevState.removeall_ids, ids]
	}))
}

handlefieldTypeChange(selectname,event) { 
	console.log(selectname,event,"select") ; 
	if(selectname=='link_to'){
       	this.setState({module_type:[event],module_type_value:event.value})

	}
	else{
       console.log("Dashboard Block selected, setting value:", event.value);
       this.setState({dashboard_block_sel:[event],dashboard_block:event.value}, () => {
	   	console.log("State updated - dashboard_block is now:", this.state.dashboard_block);
		})
	}
}

handlefieldPositionChange(event) {   
	this.setState({dashb_img_position_ob:[event],dashb_img_position:event.value})
}
onChangeHandler=event=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	reader.onloadend = () => {
	this.setState({
		image_name: file.name,
		image_preview: reader.result,
		image: file,
		image_name_single:''
	});
	};
	reader.readAsDataURL(file);
}

onChangeIconHandler = event => {
	let reader = new FileReader();
	const file = event.target.files[0];
	console.log(file, "onChangeIconHandler")
	reader.onloadend = () => {
		this.setState({
			icon_name: file.name,
			icon_preview: reader.result,
			icon_image: file,
			icon_name_single: ''
		});
	};
	reader.readAsDataURL(file);
}

removeImagePreview = () => {
	this.setState({
		image_name_single: "",
		image_preview: "" 
	});
};

removeIconImagePreview = () => {
	this.setState({
		icon_preview: "",
		icon_name_single: ""
	});
};

removeBgImagePreview = () =>{
	this.setState({
		db_bg_image_name: "",
		bg_image_preview: "" 
	});
}

onChangeBgImgHandler=event=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	console.log(file,"file")
	reader.onloadend = () => {
		this.setState({
			bg_image_name: file.name,
			bg_image_preview: reader.result,
			bg_image: file,
			db_bg_image_name:''
		});
	};
	reader.readAsDataURL(file);
}

onChangeBlockBgImgHandler = (index) => (event) => {
	let reader = new FileReader();
	const file = event.target.files[0];
	reader.onloadend = () => {
		const blocks = [...this.state.dashboard_blocks];
		blocks[index] = {
			...blocks[index],
			image: file,
			imageName: file.name,
			image_name: file.name,
			preview: reader.result,
			action: blocks[index].id ? 'update' : 'add'
		};
		this.setState({ dashboard_blocks: blocks });
	};
	reader.readAsDataURL(file);
}

removeBlockBgImagePreview = (index) => {
	const blocks = [...this.state.dashboard_blocks];
	blocks[index] = {
		...blocks[index],
		image: '',
		imageName: '',
		preview: '',
		image_name: '',
		action: blocks[index].id ? 'update' : 'add'
	};
	this.setState({ dashboard_blocks: blocks });
}

  getDisabledBlockOptions = () => {
	const { blockCounts } = this.state;
	return lang.common.dashboard_blocks.map(block => ({
		...block,
		isDisabled: blockCounts && blockCounts[block.value] !== undefined
			? blockCounts[block.value] >= block.columncount
			: false
	}));
   }
  render() {
  const {selectedOption,showlayout,login_type, image_name_single, icon_name_single,db_bg_image_name} = this.state;
			let preview = '';
			let iconPreview = null;
		
			if (image_name_single !=='') {
				const imagepre = mediaUrl+'dashboard/'+this.state.image_name_single;
				preview = <img className="img_class" src={imagepre} alt="" width={100} height={100}/>;
			}

			if(this.state.image_preview!==''){
					preview = <img className="img_class" src={this.state.image_preview} alt="" width={100} height={100}/>;
			}
			console.log(image_name_single, this.state.image_preview, '--this.state.image_preview');

			if (this.state.icon_name_single) {
				const url = mediaUrl + "dashboard/" + this.state.icon_name_single;
				iconPreview = (
					<img className="img_class" src={url} width={100} height={100} />
				);
			}

			// From uploaded file
			if (this.state.icon_preview) {
				iconPreview = (
					<img className="img_class" src={this.state.icon_preview} width={100} height={100} />
				);
			}
			console.log(this.state.dashb_img_position,this.state.dashb_img_position_ob, '--dashb_img_position');
           let bgpreview ='';
		   
					if(db_bg_image_name !=='') {
						const bgimagepre = mediaUrl+'dashboard/'+db_bg_image_name;
						bgpreview = <img className="img_class" src={bgimagepre} alt="" width={100} height={100}/>;
					}
		   
					if(this.state.bg_image_preview!==''){
							bgpreview = <img className="img_class" src={this.state.bg_image_preview} alt="" width={100} height={100}/>;
					}
  return (
   <div className="wrapper"> 
    <Header />
    <MenuSidebar  currentpage="dashboardmanagement"  currentTab="common" />		
    	<div className="content">	
    		<div className="content-wrapper">
			<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
    			<div className="success_message"></div>
				<div>
					<a class="primary-btn" href="/dashboardmanagement">Back</a>
				</div>
					<div className="title">
						<h4>Edit {this.state.login_type.value} dashboard</h4>
					</div>
    			<div className="content-body">
  			
        			<div className="builderpage-module-pagewrapper">

				

                <section className="builderpage-module-section">

				{/* <div className="sortablecontainer-module-wrapper ">
								<h2 className="typography-module-title">Blocks</h2>
								{lang.common.dashboard_blocks.map((block, index) => (
									<div key={`block-${block.value}`} className="form-group">
										<div className="form-group">
											<label>Background image ({block.label}):</label>
											<div className="choose-file">
												{this.state.isHidden && <div className="bg_image_success"></div>}
												<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBlockBgImgHandler(index)} accept="image/*"/></span>
											</div>
											{this.state.dashboard_blocks[index]?.preview && (
												<div className='d-flex gap-2 mt-2'>
													<img src={this.state.dashboard_blocks[index].preview} width={100} height={100} alt="preview" />
													<span className='fw-bold cursor-pointer' onClick={() => this.removeBlockBgImagePreview(index)}>X</span>
												</div>
											)}
											<div className="errorloaderimage"></div>
										</div>
										<label>Color (Background) ({block.label})<span class="required" style={{ color: "red" }} > * </span> : </label>
										<div className='d-flex form-field-accessibility-row'>
											<div className='form-field-accessibility-input'>
												<input type="text" className="form-control" value={this.state.dashboard_blocks[index]?.color || ''} onChange={(e) => this.handleDashboardBlockChange(index, 'color', e.target.value)}
												/>
											</div>
											<div className='form-field-accessibility-colorbx'>
												<input type="color" className="form-control" value={this.state.dashboard_blocks[index]?.color || ''} onChange={(e) => this.handleDashboardBlockChange(index, 'color', e.target.value)}
												/>
											</div>
										</div>
										<div className="errorprimaryColor"></div>
									</div>
								))}
							 </div> */}

				{this.state.name_arr.length > 0 && <> {(this.state.showlayout == true)?<> <h2 className="typography-module-title mt-5">{this.state.login_type_value} Menus <div className="sortablecontainer-module-delete-btn"><button onClick={this.getdeleteall.bind(this, this.state.field_ids)}>Delete All</button></div></h2>
				     
                       <div className="sortablecontainer-module-wrapper">
						
                         <ul>
                           {this.getformlayout()}
                         </ul>

                      </div></>:''}</>}
                  </section>
				  <form className="BuilderPage-module-form builderpage-module-section" onSubmit={ (e) => { e.preventDefault(); this.handleFormSubmit(this); }}>

						{/* <div className="form-group">
							<label>Login Type:</label>
							<input type="text" className="form-control" placeholder="Login Type" name="login_type" value={this.state.login_type} onChange={this.handleInputChange} autoComplete="off"/>
						</div> */}
						<div className="form-group">					
						<label>User Type:</label>
						<input type="text" className="form-control" placeholder="Login Type" name="login_type" value={this.state.login_type.value} onChange={this.handleInputChange} autoComplete="off" readOnly/>
						{/* <Select 
						value={login_type?login_type:{ value: 'User', label: 'User'}}
						options={lang.common.login_type} 
						onChange={this.handleChange}
						/> */}
						</div>
						{/* <div className="form-group radio-check">
						<label>Choose layout</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" checked/>
								<label className="form-check-label" for="show_count_yes">
								One Column
								</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_no" />
								<label className="form-check-label" for="show_count_no">
								Two Column
								</label>
						</div> */}
						{/* <div className="form-group">					
						<label>Status:</label>
								<Select 
								value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
								options={lang.common.status_option} 
								onChange={this.handleChange}
								/>
						</div> */}
						<h2 className="typography-module-title mt-5">Add Menu</h2>
						<div className="form-group">
						<label>Title/Tooltip:</label>
						<input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange} autoComplete="off" />
						<div className="errorname"></div>
						</div>
						<div className="form-group radio-check">
							<label>Show Tooltip:</label>
							<input className="form-check-input" type="radio" name="show_tooltip"  value="yes" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'yes'} />
								<label className="form-check-label" htmlFor="show_count_yes"> Yes </label>
							<input className="form-check-input" type="radio" name="show_tooltip"  value="no" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'no'} />
							<label className="form-check-label" htmlFor="show_count_no"> No</label>
      					</div>

						<div className="form-group">
						<label>Link To: </label>
						<Select 
						value={this.state.module_type!=''?this.state.module_type:'Choose'}
						options={lang.common.dashboard_page_options} 
						onChange={this.handlefieldTypeChange.bind(this,'link_to')}
					
						isSearchable={false}
						/>
						<div className="errormodule"></div>
						</div>
						<div className="form-group">
						<label>Block: </label>
						<Select
						value={this.state.dashboard_block_sel!=''?this.state.dashboard_block_sel:'Choose'}
						options={this.getDisabledBlockOptions()}
						onChange={this.handlefieldTypeChange.bind(this,"dashboard_block")}
						isSearchable={false}
						/>
						<div className="errormodule"></div>
						</div>
						{/* {(this.state.module_type_value == 'select' || this.state.module_type_value == 'checkbox' || this.state.module_type_value == 'radio')?<div className="form-group">
						<label>Options:</label>
						<input type="text" name="select_options" className="form-control" value={this.state.select_options} placeholder="Enter options separate by ," onChange={this.handleInputChange} autoComplete="off" />
						<div className="erroroptions"></div>
						</div>:''} */}
						
						{/* <div className="form-group">
							<label>Content : </label>
							<input type="text" name="content" className="form-control" value={this.state.content} placeholder="Content" onChange={this.handleInputChange} autoComplete="off" />
						</div> */}

						{/* <div className="form-group">
						<label>Image:</label>
						<div className="choose-file">
						{this.state.isHidden && <div className="image_success"></div>}
						<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
						</div>
						{preview!== '' && preview}
						<div className="errorloaderimage"></div>  
						</div>  */}
                        {/* <div className="form-group radio-check">
							<label>Dasboard Image Type</label>
							<input className="form-check-input" type="radio" name="dashboard_img_type" id="dashboard_img" value="dashboard_img" onChange={this.handleInputChange} checked={this.state.dashboard_img_type === 'dashboard_img'} />
							<label className="form-check-label" htmlFor="dashboard_img"> Image </label>
							<input className="form-check-input" type="radio" name="dashboard_img_type" id="dashboard_icon" value="dashboard_icon" onChange={this.handleInputChange} checked={this.state.dashboard_img_type === 'dashboard_icon'} />
							<label className="form-check-label" htmlFor="dashboard_icon"> Icon</label>
      					</div> */}

						<div className="form-group">
							<label>{this.state.dashboard_img_type === 'dashboard_icon' ? 'Icon' :'Icon'}:</label>

							{/* <label>{this.state.dashboard_img_type === 'dashboard_icon' ? 'Icon' :'Image'}:</label> */}
							<div className="choose-file">
								{this.state.isHidden && <div className="image_success"></div>}
								<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} accept="image/*"/></span>
							</div>
							{preview && preview !== '' && <div className='d-flex gap-2'>{preview} <span className='fw-bold cursor-pointer' onClick={this.removeImagePreview}>X</span></div>}
							<div className="errorloaderimage"></div>
						</div>
						{this.state.dashboard_img_type === 'dashboard_icon' &&(
							<>
								{/* <div className="form-group">
									<label>Dashboard icon max height (%):</label>
									<input type="text" name="dashb_img_max_height" className="form-control" value={this.state.dashb_img_max_height} onChange={this.handleInputChange} autoComplete="off" />
									<div className="errordashb_img_max_height"></div>
								</div>
								<div className="form-group">
									<label>Dashboard icon max width (%):</label>
									<input type="text" name="dashb_img_max_width" className="form-control" value={this.state.dashb_img_max_width} onChange={this.handleInputChange} autoComplete="off" />
									<div className="errordashb_img_max_width"></div>
								</div>
								<div className="form-group">
									<label>Dashboard icon position: </label>
									<Select 
									value={this.state.dashb_img_position_ob!=''? this.state.dashb_img_position_ob: { value: 'middle-center', label: 'Center' }}
									options={lang.common.dashboard_img_position} 
									onChange={this.handlefieldPositionChange.bind(this)}
								
									isSearchable={false}
									/>
									<div className="errordashb_img_position"></div>
								</div> */}
							</>
						)}
						<div className="form-group">
							<label>Icon width:</label>
							<input type="text" name="icon_width" className="form-control" value={this.state.icon_width}  onChange={this.handleInputChange} autoComplete="off" />
							<div className="erroriconwidth"></div>
						</div>
                        {/* <div className="form-group">
							<label>Icon color:</label>
							<div className='d-flex form-field-accessibility-row'>
											<div className='form-field-accessibility-input'>
												<input type="text" className="form-control" name="icon_color" value={this.state.icon_color || ''} onChange={this.handleInputChange}
												/>
											</div>
											<div className='form-field-accessibility-colorbx'>
												<input type="color" className="form-control" name="icon_color" value={this.state.icon_color || ''}  onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="errorprimaryColor"></div>

						</div> */}
						

						{/* <div className="form-group">
							<label>Background image:</label>
							<div className="choose-file">
								{this.state.isHidden && <div className="bg_image_success"></div>}
								<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBgImgHandler} accept="image/*"/></span>
							</div>
							{bgpreview && bgpreview !== '' && <div className='d-flex gap-2'>{bgpreview} <span className='fw-bold cursor-pointer' onClick={this.removeBgImagePreview}>X</span></div>}
							<div className="errorloaderimage"></div>
						</div>  */}
                        {/* <div className="form-group">
							<label>Icon:</label>
							<div className="choose-file">
							{this.state.isHidden && <div className="image_success"></div>}
							<span className="profile_btn">
								<input type="file" name="file" onChange={this.onChangeIconHandler} accept="image/*"/>
							</span>
							</div>
							{iconPreview && iconPreview !== '' && ( <div className="d-flex gap-2"> {iconPreview} <span className="fw-bold cursor-pointer" onClick={this.removeIconImagePreview} > X </span> </div> )}
							<div className="errorloaderimage"></div>
						</div> */}
						
						
						{/* <div className="form-group radio-check">
								<label>Show Count</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" onChange={this.handleInputChange} checked={(this.state.show_count_yes == true ? "checked" : "" )}/>
								<label className="form-check-label" for="show_count_yes">
								Yes
								</label>
								<input className="form-check-input" type="radio" name="show_count" onChange={this.handleInputChange}  id="show_count_no" checked={(this.state.show_count_no == true ? "checked" : "" )} />
								<label className="form-check-label" for="show_count_no">
								No
								</label>
						</div> */}
						<div className="form-group radio-check">
							<label>Show Count</label>
							<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" value="yes" onChange={this.handleInputChange} checked={this.state.show_count === 'yes'} />
								<label className="form-check-label" htmlFor="show_count_yes"> Yes </label>
							<input className="form-check-input" type="radio" name="show_count" id="show_count_no" value="no" onChange={this.handleInputChange} checked={this.state.show_count === 'no'} />
							<label className="form-check-label" htmlFor="show_count_no"> No</label>
      					</div>
						<div className="form-group">
							<label>Priority : </label>
							<input type="text" name="priorty" className="form-control" value={this.state.priorty}  onChange={this.handleInputChange} autoComplete="off" />
							<div className="errorpriority"></div>
						</div>
						<div className="form-group">
							<label>Text size:</label><br></br>
							<input type="input" id="head" name="text_size" className="form-control"  value={this.state.text_size} onChange={this.handleInputChange} />
							<div className="error_text_size"></div>
						</div>
					
						<div className="form-group">
							<label>Count size:</label><br></br>
							<input type="text" id="head" name="count_size" className="form-control"  value={this.state.count_size} onChange={this.handleInputChange} />
							<div className="error_count_size"></div>
						</div>

						<div className="form-group">
							<label>Text color:</label><br></br>
							<input type="color" id="head" name="text_color"  value={this.state.text_color} onChange={this.handleInputChange} />
							
							<div className="error_text_color"></div>
						</div>
						<div className='product-subscription-form-row mt-5'>
						<div className="submit-button">
						<span className="btn btn_orange btn_minwid login_submit animate-btn2" id="addbutton" onClick={this.Addtolayout}>Add</span>
						</div>
						<div className="">	
						<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
											<span className="load-data"></span> 
											}Submit
						</button>
						</div>
						</div>
						</form>
          </div>
  			</div>	
			</div>
  		</div>	
  	</div>
  </div>
  );
  }
  }

export default (withRouter(Edit));